import { useCallback, useState } from 'react'
import { PartnerStore } from 'shop/components'
import { FulfillmentType } from 'shop/types'
import { useCheckout } from '../useCheckout'

/** Encapsulates shared logic when creating a cart with default parameters via product card or product modal */
export const useCreateDefaultCart = (
  currentPartnerStore: PartnerStore | null,
  queryParamFulfillmentType: FulfillmentType,
  addItemToCart: () => void
) => {
  const [showCartSwitchModal, setShowCartSwitchModal] = useState(false)
  const { createDefaultCart } = useCheckout()

  const handleCreateDefaultCart = useCallback(() => {
    if (!currentPartnerStore) return

    createDefaultCart(currentPartnerStore, queryParamFulfillmentType)
      .then((cart) => {
        if (cart) {
          addItemToCart()
        }
      })
      .finally(() => {
        // If cart switch modal is open, close it
        setShowCartSwitchModal(false)
      })
  }, [
    currentPartnerStore,
    createDefaultCart,
    addItemToCart,
    queryParamFulfillmentType,
    setShowCartSwitchModal
  ])

  return {
    handleCreateDefaultCart,
    showCartSwitchModal,
    setShowCartSwitchModal
  }
}
